var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"job"},[_c('h4',[_c('b',[_vm._v(_vm._s(_vm.job.id))])]),_c('p',[_vm._v("Job is "+_vm._s(_vm.statusText))]),_c('div',{staticClass:"buttons"},[_c('button',{class:{
        'swal2-confirm': _vm.canDownload,
        'swal2-cancel': !_vm.canDownload,
        'swal2-styled': true,
      },attrs:{"disabled":!_vm.canDownload},on:{"click":_vm.onDownload}},[_vm._v(" Download ")]),_c('button',{class:{
        'swal2-error': _vm.canRemove,
        'swal2-cancel': !_vm.canRemove,
        'swal2-styled': true,
      },attrs:{"disabled":!_vm.canRemove},on:{"click":_vm.onRemove}},[_vm._v(" Remove ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }